'use strict';

Object.defineProperty(exports, "__esModule", {
  value: true
});

var _getPrototypeOf = require('babel-runtime/core-js/object/get-prototype-of');

var _getPrototypeOf2 = _interopRequireDefault(_getPrototypeOf);

var _classCallCheck2 = require('babel-runtime/helpers/classCallCheck');

var _classCallCheck3 = _interopRequireDefault(_classCallCheck2);

var _createClass2 = require('babel-runtime/helpers/createClass');

var _createClass3 = _interopRequireDefault(_createClass2);

var _possibleConstructorReturn2 = require('babel-runtime/helpers/possibleConstructorReturn');

var _possibleConstructorReturn3 = _interopRequireDefault(_possibleConstructorReturn2);

var _inherits2 = require('babel-runtime/helpers/inherits');

var _inherits3 = _interopRequireDefault(_inherits2);

var _react = require('react');

var _react2 = _interopRequireDefault(_react);

var _propTypes = require('prop-types');

var _propTypes2 = _interopRequireDefault(_propTypes);

var _CwTriggerField = require('../cwtriggerfield/CwTriggerField');

var _CwTriggerField2 = _interopRequireDefault(_CwTriggerField);

var _CwColorPalette = require('./CwColorPalette');

var _CwColorPalette2 = _interopRequireDefault(_CwColorPalette);

var _CwColorField = require('./CwColorField.scss');

var _CwColorField2 = _interopRequireDefault(_CwColorField);

var _CwDropdownService = require('../../utils/CwDropdownService.js');

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var CwColorField = function (_React$Component) {
  (0, _inherits3.default)(CwColorField, _React$Component);

  function CwColorField() {
    (0, _classCallCheck3.default)(this, CwColorField);

    var _this = (0, _possibleConstructorReturn3.default)(this, (CwColorField.__proto__ || (0, _getPrototypeOf2.default)(CwColorField)).call(this));

    _this.mouseDownHandler = function () {
      _this.mouseIsDownOnPalette = true;
    };

    _this.mouseUpHandler = function () {
      _this.mouseIsDownOnPalette = false;
    };

    _this.colorHexLookup = function (value) {
      var colorHex = void 0;
      var colors = _this.props.colors;
      colors.forEach(function (color) {
        if (value === color.name) {
          colorHex = color.id;
        }
      });
      return colorHex;
    };

    _this.isValidColor = function (value) {
      var regex = new RegExp('^#([A-F0-9]{6})$', "gm");
      var regexValid = regex.test(value);
      var isDefinedColor = _this.colorHexLookup(value);
      return regexValid || isDefinedColor;
    };

    _this.componentDidUpdate = function (prevProps, prevState) {
      if (_this.state.childVisible === true && prevState.childVisible === false) {
        var menuPositions = (0, _CwDropdownService.setMenuPositions)(_this.cwTriggerField.cwTextField.inputField);

        _this.setState({
          menuTop: menuPositions.menuTop,
          menuLeft: menuPositions.menuLeft
        });
      }
    };

    _this.handleScroll = function () {
      if (_this.mouseIsDownOnPalette) {
        return;
      }

      _this.collapseChild();
    };

    _this.setIgnoreBlur = function (ignore) {
      _this._ignoreBlur = ignore;
    };

    _this.onTriggerClicked = function () {
      _this.setState({ childVisible: true });
    };

    _this.handleInputFocus = function () {
      if (_this._ignoreBlur) {
        _this.setIgnoreBlur(false);
        return;
      }

      // Bring up hex to edit if focused
      _this.setState({
        selectedColorName: _this.state.selectedColor
      });

      if (_this.props.onFocus) {
        _this.props.onFocus();
      }
    };

    _this.handleInputBlur = function () {
      if (_this._ignoreBlur) return;
      _this.collapseChild();
      _this.colorLookup(_this.state.selectedColorName);

      // Check if entered value is valid
      if (_this.isValidColor(_this.state.selectedColorName)) {
        // Check if it's a new value
        if (_this.state.selectedColorName !== _this.props.value) {
          // Use looked up hex if preset, else use entered custom hex
          var colorHex = _this.colorHexLookup(_this.state.selectedColorName);
          if (colorHex) {
            _this.props.onChange(colorHex);
          } else {
            _this.props.onChange(_this.state.selectedColorName);
          }
        }
      } else {
        // Blank it out if invalid
        _this.setState({
          selectedColor: null,
          selectedColorName: ''
        });
        _this.props.onChange('');
      }

      if (_this.props.onBlur) {
        _this.props.onBlur();
      }
    };

    _this.handleClick = function (color) {
      _this.props.onChange(color.id);
      _this.focus();
      _this.setState({
        selectedColor: color.id,
        selectedColorName: color.name
      });
      _this.collapseChild();
    };

    _this.handleKeyDown = function (event) {
      if (_this.keyDownHandlers[event.key]) _this.keyDownHandlers[event.key].call(_this, event);
    };

    _this.handleChange = function (enteredText) {
      _this.setState({
        selectedColor: enteredText,
        selectedColorName: enteredText.toUpperCase()
      });
    };

    _this.state = {
      selectedColor: null,
      selectedColorName: '',
      childVisible: false
    };

    _this.mouseIsDownOnPalette = false;

    _this.keyDownHandlers = {
      ArrowDown: function ArrowDown(event) {
        event.preventDefault(); // prevent window scrolling
        this.expandChild();
      },
      Enter: function Enter() {
        this.handleInputBlur();
      },
      Escape: function Escape() {
        this.collapseChild();
      }
    };
    return _this;
  }

  (0, _createClass3.default)(CwColorField, [{
    key: 'expandChild',
    value: function expandChild() {
      this.setState({
        childVisible: true
      });
    }
  }, {
    key: 'collapseChild',
    value: function collapseChild() {
      this.setState({
        childVisible: false
      });
    }
  }, {
    key: 'colorLookup',
    value: function colorLookup(value) {
      var colors = this.props.colors;
      var colorName = '';

      // Lookup the name of the color based on its id
      colors.forEach(function (color) {
        if (value.toUpperCase() === color.id.toUpperCase()) colorName = color.name;
      });

      if (colorName === '') {
        colorName = value;
      }

      // Update the receieved color to the component's state in order to display it
      this.setState({
        selectedColor: this.colorHexLookup(value) ? this.colorHexLookup(value) : value,
        selectedColorName: colorName
      });
    }
  }, {
    key: 'componentDidMount',
    value: function componentDidMount() {
      // Display value's name and color if already given one when color picker re-mounts (i.e. after pod collapses then re-expands)
      if (this.props.value) {
        this.colorLookup(this.props.value);
      }
      window.addEventListener('scroll', this.handleScroll, true);
    }
  }, {
    key: 'componentWillUnmount',
    value: function componentWillUnmount() {
      window.removeEventListener('scroll', this.handleScroll, true);
    }
  }, {
    key: 'componentWillReceiveProps',
    value: function componentWillReceiveProps(nextProps) {
      // Display value's name and color if receiving it from the parent
      if (!nextProps.value || nextProps.value === '') {
        this.setState({
          selectedColor: null,
          selectedColorName: ''
        });
      } else {
        this.colorLookup(nextProps.value);
      }
    }
  }, {
    key: 'focus',
    value: function focus() {
      this.cwTriggerField.cwTextField.focus();
    }
  }, {
    key: 'render',
    value: function render() {
      var _this2 = this;

      var selectedColorSwatch = _react2.default.createElement('div', { style: { backgroundColor: this.state.selectedColor },
        className: _CwColorField2.default.swatchSelected
      });

      var style = { // Pass calculated position coordinates to calendar with inline style
        left: this.state.menuLeft,
        top: this.state.menuTop
      };

      return _react2.default.createElement(
        'div',
        { className: _CwColorField2.default.colorField, 'data-cwid': this.props.cwId },
        _react2.default.createElement(_CwTriggerField2.default, { triggerIcon: this.props.triggerIcon,
          cwId: this.props.cwId + '_trigger',
          ref: function ref(input) {
            return _this2.cwTriggerField = input;
          },
          onKeyDown: this.handleKeyDown,
          onChange: this.handleChange,
          onTrigger: this.onTriggerClicked,
          onFocus: this.handleInputFocus,
          onBlur: this.handleInputBlur,
          value: this.state.selectedColorName,
          customElement: selectedColorSwatch,
          regex: '^([\b^A-F,a-f,0-9,#])*$',
          maxLength: 7,
          invalid: this.props.invalid,
          disabled: this.props.disabled,
          expandOnClick: this.props.expandOnClick
        }),
        this.state.childVisible ? _react2.default.createElement(_CwColorPalette2.default, { cwId: this.props.cwId + '_palette',
          rowLength: this.props.rowLength,
          style: style,
          onClick: this.handleClick,
          onMouseDown: this.setIgnoreBlur // Ignore blur to prevent palette from de-rendering before we can process click
          , colors: this.props.colors }) : null
      );
    }
  }]);
  return CwColorField;
}(_react2.default.Component);

CwColorField.propTypes = {
  /**
   * Connectwise element id to be used as unique identifier
   */
  cwId: _propTypes2.default.string,
  /**
   *  Url of the color picker trigger
   */
  triggerIcon: _propTypes2.default.string,
  /**
   * Our initial color, can be null
   */
  value: _propTypes2.default.string,
  /**
   * A function to handle updating the color picker should at least update the value
   */
  onChange: _propTypes2.default.func,
  /**
   * Array of colors to be displayed in the color palette. "id" must be equal to the hex of the color. "name" is the text displayed in the trigger field.
   */
  colors: _propTypes2.default.arrayOf(_propTypes2.default.shape({
    id: _propTypes2.default.string,
    name: _propTypes2.default.string
  })),
  /**
   * Callback function that is fired when the component is focused
   */
  onFocus: _propTypes2.default.func,
  /**
   * Callback function that is fired when the component is blurred
   */
  onBlur: _propTypes2.default.func,
  /**
   * Used to control if colorfield is valid
   */
  invalid: _propTypes2.default.bool,
  /**
   * Used to disable colorfield
   */
  disabled: _propTypes2.default.bool,
  rowLength: _propTypes2.default.number,
  /**
   * True to expand dropdown when clicking on field, not just trigger
   */
  expandOnClick: _propTypes2.default.bool
};

exports.default = CwColorField;


//////////////////
// WEBPACK FOOTER
// ./~/cw-ui/lib/components/cwcolorfield/CwColorField.js
// module id = 821
// module chunks = 10